import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import { BuyerConfigSettingsForm } from '../models/company-buyer-config.model';
import {
  selectBuyerConfigSettings,
  selectIsLoadingBuyerConfigSettings,
  selectIsRegisteringWebhook,
  selectIsResettingBuyerConfigSettings,
  selectIsSavingBuyerConfigSettings,
  selectIsUnsubscribingWebhook,
} from './company.selectors';

@Injectable({ providedIn: 'root' })
export class CompanyBuyerConfigSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly buyerConfigSettings: Signal<
    Nullable<BuyerConfigSettingsForm>
  > = this._store.selectSignal(selectBuyerConfigSettings);
  public readonly isLoadingBuyerConfigSettings: Signal<boolean> =
    this._store.selectSignal(selectIsLoadingBuyerConfigSettings);
  public readonly isSavingBuyerConfigSettings: Signal<boolean> =
    this._store.selectSignal(selectIsSavingBuyerConfigSettings);
  public readonly isResettingBuyerConfigSettings: Signal<boolean> =
    this._store.selectSignal(selectIsResettingBuyerConfigSettings);
  public readonly isRegisteringWebhook: Signal<boolean> =
    this._store.selectSignal(selectIsRegisteringWebhook);
  public readonly isUnsubscribingWebhook: Signal<boolean> =
    this._store.selectSignal(selectIsUnsubscribingWebhook);
}
